import { TextInput } from 'components/Inputs/TextInput';
import { FormTitle } from 'components/Titles';

import { Box, Grid, Paper } from '@mui/material';

type IPartnerRejectMessage = {
  required: boolean;
  borderOrange: string;
};

export const PartnerRejectMessage: React.FC<IPartnerRejectMessage> = ({
  required,
  borderOrange,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        border: '2px solid',
        borderColor: borderOrange,
        mt: 2,
        mb: 2,
      }}
    >
      <Box p={2}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item container xs={12} md={12} mb={2}>
            <FormTitle title="Mensagem de Recusa" />
          </Grid>
        </Grid>
        <TextInput
          required={required}
          rules={{ required: 'Mensagem de rejeição não pode ficar em branco' }}
          fullWidth
          multiline
          rows={4}
          name="message"
          id="message"
          placeholder="Escreva a mensagem que será enviada para o parceiro"
        />
      </Box>
    </Paper>
  );
};

